import { render, staticRenderFns } from "./HouseBox.vue?vue&type=template&id=c11d0cd2&scoped=true&"
import script from "./HouseBox.vue?vue&type=script&lang=js&"
export * from "./HouseBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11d0cd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCarousel,VCarouselItem,VDivider})
